import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import MovieCategory from "@/pages/category/movie/page";
import TvCategory from "@/pages/category/tv/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news-detail/page";
import MediaDetail from "@/pages/detail/page";
import SearchPage from "@/pages/search/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/movie", element: <MovieCategory /> },
      { path: "category/tv", element: <TvCategory /> },
      { path: "news", element: <NewsList /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "detail/:id", element: <MediaDetail /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <About /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;